import React from 'react'
import { EventGQL } from '../../../Api'
import { PLL_LINKS } from '../../../Config/config'
import { EVENTS_YEAR } from '../../../Config/League/league.config'
import { logEvent, createDayTicketUrl, getPreviewUrl } from '../../../Utils'
import { BoxscoreActionPrimary, BoxscoreActionSecondary } from '../styles'
import { ANALYTICS_TAGS } from '../../../Constant'
import { Ticket } from '../../Icons/ticket'
import { colors } from '../../consts'
import { Lk } from '../../Links/Lk'

type ActionProps = {
  event: EventGQL
  buttonText: string
  location?: string
}

export const BoxScoreAction: React.FC<React.PropsWithChildren<ActionProps>> = ({
  event,
  buttonText,
  location,
}) => {
  const gameUrl = `${PLL_LINKS.stats}/games/${event.year || EVENTS_YEAR}/${
    event.slugname
  }`

  const handleTicketClick = () => {
    logEvent(ANALYTICS_TAGS.boxscore_click, {
      button: 'action_button',
      button_text: buttonText,
      section: 'game_ticker',
      game_slug: event?.slugname,
    })
  }

  return (
    <>
      {event.eventStatus === 0 && buttonText === 'Tickets' && (
        <Lk
          link={createDayTicketUrl(event, 'Schedule', location)}
          aria-label={`Tickets for ${event.slugname}`}
          alt={buttonText}
          onBeforeNavigate={handleTicketClick}
        >
          <Ticket iconColor={colors.black} width={24} height={24} />
        </Lk>
      )}

      {event.eventStatus === 1 && buttonText === 'Watch' && (
        <BoxscoreActionPrimary
          isLive={true}
          href={event.urlStreaming}
          aria-label={`Watch ${event.slugname}`}
          onClick={() =>
            logEvent(ANALYTICS_TAGS.boxscore_click, {
              button: 'action_button',
              button_text: buttonText,
              section: 'game_ticker',
              game_slug: event?.slugname,
            })
          }
        >
          {buttonText}
        </BoxscoreActionPrimary>
      )}

      {event.eventStatus === 0 &&
        event.awayTeam &&
        event.homeTeam &&
        buttonText === 'Preview' && (
          <BoxscoreActionSecondary
            href={getPreviewUrl(event?.slugname)}
            aria-label={`Preview ${event.slugname}`}
            onClick={() =>
              logEvent(ANALYTICS_TAGS.boxscore_click, {
                button: 'action_button',
                button_text: buttonText,
                section: 'game_ticker',
                game_slug: event?.slugname,
              })
            }
          >
            {buttonText}
          </BoxscoreActionSecondary>
        )}

      {event.eventStatus >= 1 && buttonText === 'View Stats' && (
        <BoxscoreActionSecondary
          href={gameUrl}
          aria-label={`Game Stats for ${event.slugname}`}
          onClick={() =>
            logEvent(ANALYTICS_TAGS.boxscore_click, {
              button: 'action_button',
              button_text: buttonText,
              section: 'game_ticker',
              game_slug: event?.slugname,
            })
          }
        >
          {buttonText}
        </BoxscoreActionSecondary>
      )}
    </>
  )
}
